module.exports = __webpack_public_path__ + "static/media/classic_car_new.c7a83e88.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/classic_car_new.svg
// module id = 3197
// module chunks = 0